import { config } from '@/lib/config';

const SENT_KEY = 'crm_referral_click_sent';

/**
 * Top of the referral funnel: a visitor arrived with `?ref=CODE`. Reported
 * once per session to the public beacon (the server dedupes per visitor
 * and day on top). Fire-and-forget — never blocks boot, never throws.
 */
export function reportReferralClick(): void {
  if (typeof window === 'undefined') return;
  try {
    const code = new URLSearchParams(window.location.search).get('ref')?.trim();
    if (!code || !/^(tgd-?)?[a-z0-9-]{6,12}$/i.test(code)) return;
    if (sessionStorage.getItem(SENT_KEY) === code) return;
    sessionStorage.setItem(SENT_KEY, code);

    const body = JSON.stringify({
      code,
      landingPage: window.location.href.slice(0, 2000),
      referrer: document.referrer ? document.referrer.slice(0, 2000) : undefined,
    });
    void fetch(`${config.apiBaseUrl}/api/public/v1/referral/click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Storage or URL access denied — attribution still works without the click.
  }
}
